var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOpensea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_273_823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM26.0526 14.9887C27.0919 15.178 28.7222 15.5258 29.5391 15.8729C29.6686 15.928 29.8247 15.8343 29.8247 15.6926V13.7231C29.8247 13.6728 29.8448 13.6246 29.8825 13.5917C30.4217 13.1197 31.6519 12.5381 32.7544 13.5911C32.7892 13.6243 32.8087 13.6715 32.8087 13.7198V16.7248C32.8087 16.7927 32.8443 16.8538 32.9035 16.886C34.8392 17.9408 38.7752 21.048 39.7714 25.496C40.3094 28.6603 37.4682 32.0936 35.569 33.573C35.5376 33.5975 35.5 33.6098 35.4604 33.6098H32.9895C32.8896 33.6098 32.8087 33.6915 32.8087 33.7922V36.6183C32.8087 36.719 32.8896 36.8007 32.9895 36.8007H35.8831C36.3352 36.8007 37.4565 36.5454 38.3246 35.5243C39.4052 34.2533 40.3961 33.7959 41.8332 33.6121C41.845 33.6106 41.8563 33.6081 41.8676 33.6043C43.56 33.0359 46.9273 31.9628 47.8417 31.8796C47.9325 31.8714 48 31.9467 48 32.0386V33.933C48 34.0121 47.95 34.0815 47.8764 34.1088C46.7961 34.5093 44.571 35.9097 43.3884 38.7152C43.3104 38.8509 43.2319 38.9917 43.1515 39.1359C42.2058 40.8318 40.9968 43 37.3299 43H22.7716C20.2623 42.6988 15.2308 40.4337 15.0001 33.7908C14.9967 33.6917 15.0704 33.6098 15.1688 33.6098H22.9366C23.043 33.6098 23.1244 33.7014 23.1252 33.8086C23.1343 35.1651 24.4244 37.38 29.6615 36.8189C29.7529 36.8091 29.8247 36.7308 29.8247 36.6382V33.7922C29.8247 33.6915 29.7437 33.6098 29.6438 33.6098H26.1843C26.0243 33.6098 25.9388 33.4148 26.0431 33.2926C28.2654 30.6875 30.935 23.9782 25.8692 15.2657C25.791 15.1312 25.9005 14.9609 26.0526 14.9887ZM24.0537 18.8202L16.8065 29.9543C16.7276 30.0755 16.8138 30.2367 16.9577 30.2367H24.3303C24.3747 30.2367 24.4165 30.2214 24.449 30.1909C25.8105 28.9118 27.5971 24.9529 24.363 18.8361C24.2989 18.7149 24.1285 18.7054 24.0537 18.8202Z",
    fill: "url(#paint0_linear_273_823)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_273_823",
    x: -400,
    y: -400,
    width: 860,
    height: 860,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 200
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_273_823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_273_823",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_823",
    x1: 0,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpensea);
export default __webpack_public_path__ + "static/media/icon-opensea.42df3edf06916a8ae6727767fd51b87e.svg";
export { ForwardRef as ReactComponent };